import { render } from "./CommonDistrictSelector.vue?vue&type=template&id=c661b1c2&ts=true&lang=pug"
import script from "./CommonDistrictSelector.vue?vue&type=script&lang=ts"
export * from "./CommonDistrictSelector.vue?vue&type=script&lang=ts"

import "./CommonDistrictSelector.vue?vue&type=style&index=0&id=c661b1c2&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__